<template>
  <div class="row">
    <div class="Ticket" id="Ticket">

      <!-- Ticket -->
      <div class="pageBreak ticket-container">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic my-3" 
                >
                  <img :src="logo" width="280px" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-12 d-flex justify-content-center">
              <h1>TACOS HERIS</h1>
            </div> -->
              <div class="col-12 d-flex justify-content-center">
                <h2 class="table-normal-body">JULIETA ESTEFANIA ARRIETA CASTAÑEDA</h2>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3 class="table-normal-body">RFC: AICJ920927E11</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3 class="text-center table-normal-body">
                  {{sucursal.direccion}}
                </h3>
              </div>
              <div class="col-12 d-flex justify-content-center tipo-consumo-container">
                <div class="tipo-consumo">
                  <p class="text-uppercase align-self-center">CONSUMO {{getConsumo(orden.consumo)}}</p>

                  <div v-if="orden.consumo == 'domicilio'">                  
                      <div class="text-justified table-normal-body"><pre>{{ getDomicilio() }}</pre></div>                  
                  </div>
                  
                  <div v-if="orden.consumo == 'sucursal'">
                    <div class="text-center table-normal-body"><pre> Mesa #{{orden.mesa}}</pre></div>
                  </div>

                  <div v-if="orden.consumo == 'recoger'">                  
                    <div class="text-center table-normal-body"><pre> Nombre: {{orden.nombreCliente}}, <br> Teléfono: {{orden.telefonoCliente}}</pre></div>                  
                  </div>

                  <div v-if="orden.consumo == 'llevar'">                  
                    <div class="text-center table-normal-body"><pre> Nombre: {{orden.nombreCliente}} </pre></div>                  
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center folio-cont my-2">
                <h3 class="table-normal-body"> FOLIO:{{ orden.folio }} </h3>
              </div>
              <div class="col-12 d-flex justify-content-center mb-3">
                <h3 class="table-normal-body">{{ getDateTime() }}</h3>
              </div>
            </div>

            <!-- <table
              v-for="(cuenta, cIdx) in cuentas"
              v-bind:key="cIdx"
              class="detalle mb-5"
            >
              <thead>
                <tr>
                  <th style="font-weight: unset !important" class="text-center">
                    Cantidad
                  </th>
                  <th style="font-weight: unset !important" class="text-center">
                    Concepto
                  </th>
                  
                  <th style="font-weight: unset !important" class="text-right">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(plato, pIdx) in cuenta" v-bind:key="pIdx">
                  <td class="text-center">{{ plato.cantidad }}</td>
                  <td>{{ plato.nombre }}</td>

                  <td class="text-right">
                    {{ calculaPrecio(plato.precio, plato.cantidad) }}.00
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Total</td>
                  <td class="text-right">
                    <strong> ${{ orden.aPagarTotal }}.00</strong>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Recibido</td>
                  <td class="text-right">
                    <strong> ${{ orden.cantidadEntregada }}.00</strong>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Cambio</td>
                  <td class="text-right">
                    <strong> ${{ orden.cambio }}.00</strong>
                  </td>
                </tr>
              </tbody>
            </table> -->
            
            <div style="padding-right:15px">
            <table class="detalle mb-5">
              <thead>
                <tr>
                  <th class="text-center table-bold-header mb-1" width="30px">
                    Cant
                  </th>
                  <th class="text-center table-bold-header mb-1" width="350px">
                    Concepto
                  </th>
                  <th class="text-right table-bold-header mb-1" width="75px">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(plato, pIdx) in orden.resPlatos" v-bind:key="pIdx" style="margin-bottom: 9px;">
                  <td class="text-center mb-2">
                    <div class="mb-2 table-normal-body">{{ plato.cantidad }}</div>
                  </td>
                  <td>
                    <div class="mb-2 table-normal-body" >{{ plato.alimento.nombre }}</div>
                  </td>

                  <td class="text-right">
                    <div class="table-normal-body">{{ calculaPrecio(plato.alimento.precio, plato.cantidad) }}.00</div>
                  </td>
                </tr>
                <tr v-if="orden.consumo == 'domicilio'">
                  <td></td>
                  <td class="text-right table-bold-header">
                    <div class="mb-2 mt-2">Cobro Envio</div>
                  </td>
                  <td class="text-right">
                    <div class="mb-2 mt-2"> <strong> ${{ orden.cobroEnvio }}.00</strong> </div>
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td class="text-right table-bold-header">
                    <div class="mb-2 mt-2">Total</div>
                  </td>
                  <td class="text-right">
                    <div class="mb-2 mt-2"> <strong> ${{ getTotalPagar() }}.00</strong> </div>
                  </td>
                </tr>

                <tr v-if="!isNaN(orden.cantidadEntregada)">
                  <td></td>
                  <td class="text-right"><div class="mb-2 mt-2 table-normal-body">Recibido</div></td>
                  <td class="text-right">
                    <div class="mb-2 mt-2 table-normal-body">${{ orden.cantidadEntregada }}.00</div>
                  </td>
                </tr>
                <tr v-if="!isNaN(orden.cantidadEntregada)">
                  <td></td>
                  <td class="text-right"><div class="mb-2 mt-2 table-normal-body">Cambio</div></td>
                  <td class="text-right">
                     <div class="mb-2 mt-2 table-normal-body">${{ orden.cantidadEntregada - orden.aPagarTotal }}.00</div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>

            <div class="col-12 d-flex justify-content-center mt-2 dashed-top">
              <div class="mt-2">
              <h3 class="text-center table-normal-body">
                -- GRACIAS POR SU PREFERENCIA --
              </h3>
              </div>
            </div>
            <!-- <span class="mb-3"></span> -->
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alert.vue";
import Sucursal from '@/modules/restaurant/models/Sucursal.js';
import ResOrdenes from "@/modules/restaurant/models/ResOrdenes.js";

export default {
  name: "PrintTicketV2",

  props: ["ordenId"],
  data() {
    return {
      title: "Cerrar cuenta",
      logo: "/img/WideLogo.png",
      orden: ResOrdenes.init(this.ordenId, this.loadOrden),
      sucursal: null,
    };
  },
  components: {
    // SideMenu,
    // TopBar,
    Alert,
  },
  methods: {
    loadOrden(res) {
      var sid = Sucursal.getSucursal()
      if(sid == null){
        console.log("error en sucursal")
      }else{
        const _this = this;
        console.log("resordenes", res);
        _this.orden = res.data.item;
        _this.sucursal = sid
        _this.printTicket()
      }
    },
    printTicket() {
      setTimeout(()=>{
        this.currentTicket = 0;
        setTimeout(()=>{
          window.print()
          setTimeout(()=>{
            window.close()
          }, 300);
        }, 400);
      }, 300);
    },
    calculaPrecio(precio, cantidad) {
      return parseFloat(precio) * parseFloat(cantidad);
    },
    getDomicilio(){
      let dom = this.orden.cliente.resDomicilio
      var domPrincipal = `Domicilio: #${dom.numeroExt} ${dom.calle}, ${dom.colonia}.`;
      if(dom.entreCalles != ""){
        domPrincipal+= "\n"+`Entre calles: ${dom.entreCalles}.`
      }
      if(dom.entreCalles != ""){
        domPrincipal+= "\n"+`Referencia: ${dom.referencia}.`
      }
      return domPrincipal
    },
    getConsumo(id){
      if(id == "llevar"){
        return "para llevar"
      }
      if(id == "recoger"){
        return "para recoger"
      }
      if(id == "sucursal"){
        return "en sucursal"
      }
      return "a domicilio"
    },
    getDateTime(){
      let date = new Date();

      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let hour = date.getHours();
      let minute = date.getMinutes();
      if(minute < 10){
        minute = `0${minute}`
      }
      let dateTime;
      if (month < 10) {
        dateTime = `${day}-0${month}-${year} ${hour}:${minute}`;
      } else {
        dateTime = `${day}-${month}-${year} ${hour}:${minute}`;
      }
      return dateTime
    },
    getTotalPagar(){
      let total = 0;
      this.orden.resPlatos.forEach(plato => {
        total += this.calculaPrecio(plato.alimento.precio, plato.cantidad)
      });
      if(this.orden.consumo == 'domicilio'){
        return total += this.orden.cobroEnvio
      }
      return total
    }
  },
};
</script>

<style scoped>
* {
  background: white !important;
  color: black !important;
  font-weight: bold;
}
.rowTicket {
  padding-left: 10px;
}
/* .ticket {
  width: 80mm;
  border: 1px solid black;
  padding-left: 15px;
  margin-left: 16px;
} */

h1,
h2,
h3 {
  margin: 0;
}

h1 {
  font-size: 20px;
  font-family: "Times New Roman", Times, serif;
}
h2,
h3,
h4,
.detalle,
table,
th,
td {
  font-size: 12px !important;
  font-family: 'Fira Code', monospace;
  text-transform: uppercase;
}
.detalle {
  /* padding: 0!important; */
  margin: 0 auto;
}
.lista-tacos{
  text-align: center;
}

pre{
  all: initial;
  font-size: 12px !important;
  font-family: 'Fira Code', monospace;
  font-weight: 500 !important;
  text-transform: uppercase;
  color: black;
}

.tipo-consumo-container{
  border-top: 2px dashed black;
  border-bottom: 2px dashed black;
  margin: 8px 0;
}
.tipo-consumo{
  padding-top: 8px;
  padding-bottom: 8px;
}
.tipo-consumo > p{
  font-size: 18px !important;
  font-weight: bolder !important;
  margin-bottom: 4px;
}
.table-bold-header{
  font-weight: bolder !important;
}
.table-normal-body{
  font-weight: 500 !important;
}
.dashed-top{
  border-top:2px dashed black;
}
.folio-cont > h3{
  font-size: 22px !important;
}
@media print {
  * {
    background: white !important;
    color: black !important;
    /* font-size: 14px; */
  }
  .folio-cont > h3{
    font-size: 22px !important;
  }
  #NoTicket {
    display: none;
  }
  .ticket-container{
    width: 100%;
    margin-left: 0;
  }
  .Ticket {
    background-color: white;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    margin: 0;
    padding: 18px;
    font-size: 22px;
    line-height: 18px;
    position: fixed;
  }
  .pic
  {
    margin-top: 10px; 
    margin-bottom: 5px;
  }
  .pic img {
    width: 80%;
  }
  .rowTicket {
    /* padding-left: 10px; */
    padding: 0;
    /* height: 100%; */
  }
  .ticket {
    /* width: 80mm; */
    /* border: 1px solid black; */
    /* border:  none; */
    /* padding-left: 15px;
    margin-left: 16px; */
  }

  h1,
  h2,
  h3 {
    margin: 0;
  }

  h1 {
    font-size: 20px;
    font-family: 'Fira Code', monospace;
  }
  h2,
  h3,
  h4,
  .detalle,
  table,
  th,
  td,
  pre {
    font-size: 18px !important;
    font-family: 'Fira Code', monospace;
    text-transform: uppercase;
    font-weight: 300 !important;
  }
  .pre{
    font-weight: 500 !important;
  }
  .detalle {
    /* padding: 0!important; */
    margin: 0 auto;
  }
  .pageBreak {
    page-break-before : always;
    page-break-after: always;
    clear: both;
  }
  .table-bold-header{
    font-weight: bolder !important;
  }
  .table-normal-body{
    font-weight: 500 !important;
  }
}
</style>